import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Accounting from "./accounting";
import AuthContext from "../../context/AuthContext";
import { API_URL } from "../../components/api";

function Collectors() {
  const { user } = useContext(AuthContext);
  const history = useHistory();
  const [hasAccess, setHasAccess] = useState(null);

  useEffect(() => {
    let mounted = true;

    const checkAccess = async () => {
      try {
        const authTokens = JSON.parse(
          localStorage.getItem("authTokens") ||
            "null"
        );

        if (!authTokens || !authTokens.access) {
          throw new Error(
            "Missing access token."
          );
        }

        const response = await axios.get(
          `${API_URL}/accounting/collectors/access/`,
          {
            headers: {
              Authorization:
                `Bearer ${authTokens.access}`,
            },
          }
        );

        if (!mounted) {
          return;
        }

        const allowed =
          response.data &&
          response.data.allowed === true;

        setHasAccess(allowed);

        if (!allowed) {
          history.replace("/");
        }
      } catch (error) {
        console.error(
          "Collectors access check failed:",
          error
        );

        if (mounted) {
          setHasAccess(false);
          history.replace("/");
        }
      }
    };

    checkAccess();

    return () => {
      mounted = false;
    };
  }, [history, user.username]);

  if (hasAccess !== true) {
    return null;
  }

  return <Accounting collectorsOnly />;
}

export default Collectors;
